import { type SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { useQueryReviseFormDefaults } from '../../models'

interface UseGetReviseFormDefaultsPresenterReturn {
  defaultDepartment: Nullable<SecondaryCategory>
  isLoading: boolean
}

export const useGetReviseFormDefaultsPresenter = (
  locationId: number,
  departmentId: number
): UseGetReviseFormDefaultsPresenterReturn => {
  const { data, isLoading } = useQueryReviseFormDefaults(
    locationId,
    departmentId
  )

  return {
    defaultDepartment: data?.defaultDepartment ?? null,
    isLoading,
  }
}
